import _ from 'lodash';

export const BUSINESS_SEGMENT_VALUES = [
    'Agriculture, Forestry and Fishing',
    'Correctional Facilities',
    'Critical Gas Infrastructure',
    'Data Center',
    'Data Center with Crypto Mining',
    'Hospitals',
    'Industrial/Manufacturing',
    'Mining',
    'Multiple Dwelling Unit',
    'Office Building',
    'Residential',
    'Retail Service',
    'Schools',
    'Services',
    'Transportation, Communications, Electric, Gas and Sanitary Services',
];

export const EDC_VALUES = [
    'AE',
    'AECI',
    'AEPAPT',
    'AEPIMP',
    'AEPKPT',
    'AEPOPT',
    'AETSAP',
    'AMPO',
    'APWVP',
    'BATAV',
    'BC',
    'BRLNMD',
    'BSHNJ',
    'BSRNJ',
    'BUCK',
    'CHBDTE',
    'CITYAU',
    'COMED',
    'CPP',
    'CTZECL',
    'CVEC',
    'DAYEDC',
    'DEK',
    'DEMEC',
    'DEOEDC',
    'DLCO',
    'DOMEDC',
    'DOMVME',
    'DOVDE',
    'DPL',
    'EASTON',
    'EKPC',
    'EPPHAG',
    'FESCHG',
    'FESCTH',
    'FESCWP',
    'GENEVA',
    'HEREC',
    'IMEAA1',
    'JCBGS',
    'MetEd',
    'NAPRVL',
    'NVEC',
    'ODEC',
    'OEEDC',
    'PaElec',
    'PAPWR',
    'PE',
    'PEPCO',
    'PPL',
    'PSEG',
    'PTST5',
    'RADFRD',
    'RECO',
    'ROCH',
    'SALEM',
    'SESEDC',
    'SMECO',
    'STURGS',
    'THRMT',
    'UGI-UI',
    'VATECH',
    'VMEU',
    'WELLSB',
    'WMSPT',
    'WVPA',
    'WVSDI',
] as const;

export const RESIDENTIAL_PROGRAM_TYPE = ['DLC', 'BEHAVIOR_INCENTIVE', 'BEHAVIOR_PENALTY'];

export const METER_TYPE = ['EDC_METER']; //['CSP_METER', 'EDC_METER'];

export const REGISTRATION_PROGRAM = [
    'Economic',
    'Load Management DR Full',
    'Load Management DR Capacity Only',
    'Emergency Energy Only',
    'Price Responsive Demand',
    'Peak Shaving Adjustment',
];

export const REGISTRATION_MEASUREMENT_METHOD = ['FIRM_SERVICE_LEVEL', 'GUARANTEED_LOAD_DROP', 'GUARANTEED_LOAD_DROP_BYGEN', 'MESL', 'PILOT'];

export const REGISTRATION_PRODUCT_TYPE = [
    'BASE_DR',
    'CAPACITY_PERFORMANCE_DR',
    'LIMITED_DR',
    'EXTENDED_SUMMER_DR',
    'ANNUAL_DR',
    'PRICE_RESPONSIVE_DEMAND',
];

export const REGISTRATION_RESOURCE_TYPE = ['EMERGENCY', 'PRE_EMERGENCY'];

export const REGISTRATION_RETAIL_RATE_TYPE = ['DAY_AHEAD_LMP', 'FIXED_PRICE', 'REAL_TIME_LMP', 'OTHER'];

export const REGISTRATION_LEAD_TIME = ['Quick_30', 'Short_60', 'Long_120'];
export const REGISTRATION_LEAD_EXCEPTION = ['Manufacturing damage', 'Generation start time', 'Safety problem', 'Mass market comm'];

export const EDC_DEP_MAP: Record<string, { zone: string[]; state: string[]; edcAccountNo: { min: number; max: number; numericOnly: boolean } }> = {
    AE: {
        zone: ['AECO'],
        state: ['NJ'],
        edcAccountNo: {
            min: 22,
            max: 22,
            numericOnly: true,
        },
    },
    AECI: {
        zone: ['APS', 'JCPL', 'METED', 'PENELEC', 'PPL'],
        state: ['NJ', 'PA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: true,
        },
    },
    AEPAPT: {
        zone: ['AEP'],
        state: ['TN', 'VA', 'WV'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: false,
        },
    },
    AEPIMP: {
        zone: ['AEP'],
        state: ['IN', 'MI'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: false,
        },
    },
    AEPKPT: {
        zone: ['AEP'],
        state: ['KY'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: false,
        },
    },
    AEPOPT: {
        zone: ['AEP'],
        state: ['OH'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: false,
        },
    },
    AETSAP: {
        zone: ['APS'],
        state: ['MD', 'PA', 'VA', 'WV'],
        edcAccountNo: {
            min: 20,
            max: 20,
            numericOnly: true,
        },
    },
    AMPO: {
        zone: ['AEP', 'APS', 'ATSI', 'DAY', 'DEOK', 'DOM', 'METED', 'PENELEC', 'PPL'],
        state: ['KY', 'MI', 'OH', 'PA', 'VA', 'WV'],
        edcAccountNo: {
            min: 7,
            max: 20,
            numericOnly: false,
        },
    },
    APWVP: {
        zone: ['AEP'],
        state: ['WV'],
        edcAccountNo: {
            min: 20,
            max: 20,
            numericOnly: true,
        },
    },
    BATAV: {
        zone: ['COMED'],
        state: ['IL'],
        edcAccountNo: {
            min: 5,
            max: 15,
            numericOnly: false,
        },
    },
    BC: {
        zone: ['BGE'],
        state: ['MD'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: false,
        },
    },
    BRLNMD: {
        zone: ['DPL'],
        state: ['MD'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    BSHNJ: {
        zone: ['JCPL'],
        state: ['NJ'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: true,
        },
    },
    BSRNJ: {
        zone: ['PSEG'],
        state: ['NJ'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: false,
        },
    },
    BUCK: {
        zone: ['AEP', 'ATSI', 'DAY', 'DEOK'],
        state: ['OH'],
        edcAccountNo: {
            min: 4,
            max: 11,
            numericOnly: true,
        },
    },
    CHBDTE: {
        zone: ['APS', 'COMED'],
        state: ['IL', 'PA'],
        edcAccountNo: {
            min: 9,
            max: 10,
            numericOnly: true,
        },
    },
    CITYAU: {
        zone: ['AEP'],
        state: ['IN'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    COMED: {
        zone: ['COMED'],
        state: ['IL'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: false,
        },
    },
    CPP: {
        zone: ['ATSI'],
        state: ['OH'],
        edcAccountNo: {
            min: 5,
            max: 12,
            numericOnly: false,
        },
    },
    CTZECL: {
        zone: ['PPL'],
        state: ['PA'],
        edcAccountNo: {
            min: 7,
            max: 8,
            numericOnly: true,
        },
    },
    CVEC: {
        zone: ['DOM'],
        state: ['VA'],
        edcAccountNo: {
            min: 9,
            max: 10,
            numericOnly: false,
        },
    },
    DAYEDC: {
        zone: ['DAY'],
        state: ['OH'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: true,
        },
    },
    DEK: {
        zone: ['DEOK'],
        state: ['KY'],
        edcAccountNo: {
            min: 12,
            max: 12,
            numericOnly: false,
        },
    },
    DEMEC: {
        zone: ['DPL'],
        state: ['DE'],
        edcAccountNo: {
            min: 5,
            max: 15,
            numericOnly: false,
        },
    },
    DEOEDC: {
        zone: ['DEOK'],
        state: ['OH'],
        edcAccountNo: {
            min: 10,
            max: 12,
            numericOnly: false,
        },
    },
    DLCO: {
        zone: ['DUQ'],
        state: ['PA'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: false,
        },
    },
    DOMEDC: {
        zone: ['DOM'],
        state: ['NC', 'VA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: false,
        },
    },
    DOMVME: {
        zone: ['DOM'],
        state: ['VA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: true,
        },
    },
    DOVDE: {
        zone: ['DPL'],
        state: ['DE'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: true,
        },
    },
    DPL: {
        zone: ['DPL'],
        state: ['DE', 'MD'],
        edcAccountNo: {
            min: 22,
            max: 22,
            numericOnly: true,
        },
    },
    EASTON: {
        zone: ['DPL'],
        state: ['MD'],
        edcAccountNo: {
            min: 12,
            max: 13,
            numericOnly: false,
        },
    },
    EKPC: {
        zone: ['EKPC'],
        state: ['KY'],
        edcAccountNo: {
            min: 5,
            max: 13,
            numericOnly: false,
        },
    },
    EPPHAG: {
        zone: ['APS'],
        state: ['MD'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    FESCHG: {
        zone: ['APS'],
        state: ['MD'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: false,
        },
    },
    FESCTH: {
        zone: ['APS'],
        state: ['MD'],
        edcAccountNo: {
            min: 7,
            max: 8,
            numericOnly: false,
        },
    },
    FESCWP: {
        zone: ['APS'],
        state: ['MD'],
        edcAccountNo: {
            min: 8,
            max: 8,
            numericOnly: false,
        },
    },
    GENEVA: {
        zone: ['COMED'],
        state: ['IL'],
        edcAccountNo: {
            min: 13,
            max: 13,
            numericOnly: false,
        },
    },
    HEREC: {
        zone: ['AEP'],
        state: ['IN'],
        edcAccountNo: {
            min: 9,
            max: 11,
            numericOnly: true,
        },
    },
    IMEAA1: {
        zone: ['COMED'],
        state: ['IL'],
        edcAccountNo: {
            min: 5,
            max: 10,
            numericOnly: false,
        },
    },
    JCBGS: {
        zone: ['JCPL'],
        state: ['NJ'],
        edcAccountNo: {
            min: 20,
            max: 20,
            numericOnly: true,
        },
    },
    MetEd: {
        zone: ['METED'],
        state: ['PA'],
        edcAccountNo: {
            min: 20,
            max: 20,
            numericOnly: true,
        },
    },
    NAPRVL: {
        zone: ['COMED'],
        state: ['IL'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    NVEC: {
        zone: ['DOM'],
        state: ['VA'],
        edcAccountNo: {
            min: 9,
            max: 11,
            numericOnly: true,
        },
    },
    ODEC: {
        zone: ['AEP', 'APS', 'DOM', 'DPL'],
        state: ['DE', 'MD', 'VA'],
        edcAccountNo: {
            min: 7,
            max: 12,
            numericOnly: true,
        },
    },
    OEEDC: {
        zone: ['ATSI'],
        state: ['OH'],
        edcAccountNo: {
            min: 20,
            max: 20,
            numericOnly: false,
        },
    },
    PaElec: {
        zone: ['PENELEC'],
        state: ['NY', 'PA'],
        edcAccountNo: {
            min: 20,
            max: 20,
            numericOnly: true,
        },
    },
    PAPWR: {
        zone: ['ATSI'],
        state: ['PA'],
        edcAccountNo: {
            min: 20,
            max: 20,
            numericOnly: false,
        },
    },
    PE: {
        zone: ['PECO'],
        state: ['PA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: false,
        },
    },
    PEPCO: {
        zone: ['PEPCO'],
        state: ['DC', 'MD'],
        edcAccountNo: {
            min: 22,
            max: 22,
            numericOnly: true,
        },
    },
    PPL: {
        zone: ['PPL'],
        state: ['PA'],
        edcAccountNo: {
            min: 8,
            max: 12,
            numericOnly: false,
        },
    },
    PSEG: {
        zone: ['PSEG'],
        state: ['NJ'],
        edcAccountNo: {
            min: 10,
            max: 13,
            numericOnly: false,
        },
    },
    PTST5: {
        zone: [
            'AECO',
            'AEP',
            'APS',
            'ATSI',
            'BGE',
            'COMED',
            'DAY',
            'DEOK',
            'DOM',
            'DPL',
            'DUQ',
            'EKPC',
            'JCPL',
            'METED',
            'OVEC',
            'PECO',
            'PENELEC',
            'PEPCO',
            'PPL',
            'PSEG',
            'RECO',
        ],
        state: ['DC', 'DE', 'IL', 'IN', 'KY', 'MD', 'MI', 'NC', 'NJ', 'NY', 'OH', 'PA', 'TN', 'VA', 'WV'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    RADFRD: {
        zone: [
            'AECO',
            'AEP',
            'APS',
            'ATSI',
            'BGE',
            'COMED',
            'DAY',
            'DEOK',
            'DOM',
            'DPL',
            'DUQ',
            'EKPC',
            'JCPL',
            'METED',
            'OVEC',
            'PECO',
            'PENELEC',
            'PEPCO',
            'PPL',
            'PSEG',
            'RECO',
        ],
        state: ['DC', 'DE', 'IL', 'IN', 'KY', 'MD', 'MI', 'NC', 'NJ', 'NY', 'OH', 'PA', 'TN', 'VA', 'WV'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: false,
        },
    },
    RECO: {
        zone: ['RECO'],
        state: ['NJ', 'PA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: false,
        },
    },
    ROCH: {
        zone: ['COMED'],
        state: ['IL'],
        edcAccountNo: {
            min: 1,
            max: 7,
            numericOnly: true,
        },
    },
    SALEM: {
        zone: ['AEP'],
        state: ['VA'],
        edcAccountNo: {
            min: 10,
            max: 10,
            numericOnly: true,
        },
    },
    SESEDC: {
        zone: ['APS', 'DOM'],
        state: ['VA'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    SMECO: {
        zone: ['APS', 'DOM'],
        state: ['VA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: false,
        },
    },
    STURGS: {
        zone: ['AEP'],
        state: ['MI'],
        edcAccountNo: {
            min: 19,
            max: 19,
            numericOnly: false,
        },
    },
    THRMT: {
        zone: ['APS'],
        state: ['MD'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    'UGI-UI': {
        zone: ['PPL'],
        state: ['PA'],
        edcAccountNo: {
            min: 12,
            max: 13,
            numericOnly: true,
        },
    },
    VATECH: {
        zone: ['AEP'],
        state: ['VA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: true,
        },
    },
    VMEU: {
        zone: ['AEP'],
        state: ['VA'],
        edcAccountNo: {
            min: 9,
            max: 12,
            numericOnly: true,
        },
    },
    WELLSB: {
        zone: ['PENELEC'],
        state: ['PA'],
        edcAccountNo: {
            min: 10,
            max: 11,
            numericOnly: true,
        },
    },
    WMSPT: {
        zone: ['APS'],
        state: ['MD'],
        edcAccountNo: {
            // no specific rules about length at DRHUB
            min: 1,
            max: 100,
            numericOnly: false,
        },
    },
    WVPA: {
        zone: ['AEP'],
        state: ['IN'],
        edcAccountNo: {
            min: 5,
            max: 20,
            numericOnly: false,
        },
    },
    WVSDI: {
        zone: ['AEP'],
        state: ['IN'],
        edcAccountNo: {
            min: 3,
            max: 11,
            numericOnly: true,
        },
    },
};

export const ZONE_DEP_MAP: Record<string, { pricingPoint: string[] }> = {
    AECO: {
        pricingPoint: ['AECO_RESID_AGG', 'VINELAND_RESID_AGG', 'VINELAND'],
    },
    APS: {
        pricingPoint: ['APS_RESID_AGG', 'AEC - AP', 'HREA - AP', 'MONT ALTO - AP', 'NEWMARTINSVILLE-AP', 'PHILIPPI - AP', 'TARENTUM - AP'],
    },
    JCPL: {
        pricingPoint: ['JCPL_RESID_AGG'],
    },
    METED: {
        pricingPoint: ['METED_RESID_AGG', 'AMP-METED'],
    },
    PENELEC: {
        pricingPoint: ['PENELEC_RESID_AGG', 'WELLSBORO'],
    },
    PPL: {
        pricingPoint: ['PPL_RESID_AGG', 'UGI_RESID_AGG', 'CITIZENS', 'EPHRATA', 'OLYPHANT', 'PERKASIE', 'SULLIVAN', 'TRI-COUNTY'],
    },
    AEP: {
        pricingPoint: [
            'AEPAPCO_RESID_AGG',
            'AEPIM_RESID_AGG',
            'AEPKY_RESID_AGG',
            'AEPOHIO_RESID_AGG',
            'AMP-OHIO',
            'BLUE RIDGE',
            'BUCKEYE - AEP',
            'BUCKEYE-AEPIM ',
            'BUCKEYE-AEPOH ',
            'MERIDIAN EWHITLEY',
        ],
    },
    ATSI: {
        pricingPoint: ['FEOHIO_RESID_AGG', 'PENNPOWER_RESID_AGG', 'AMP-ATSI OH', 'AMP-ATSI PA', 'BUCK-FE', 'CPP'],
    },
    DAY: {
        pricingPoint: ['DAY_RESID_AGG', 'BUCKEYE - DPL'],
    },
    DEOK: {
        pricingPoint: ['DEOK_RESID_AGG', 'BUCK-CIN', 'DEK', 'EKPC-DEOK LOAD', 'WILLIAMSTOWN'],
    },
    DOM: {
        pricingPoint: ['DOM_RESID_AGG'],
    },
    COMED: {
        pricingPoint: ['COMED_RESID_AGG', 'BATAVIA', 'GENEVA', 'NAPERVILLE', 'ROCHELLE', 'ROCK FALLS', 'ST. CHARLES', 'WINNETKA'],
    },
    BGE: {
        pricingPoint: [
            'BGE_RESID_AGG',
            'BAGLEY  34 KV   230-1LD',
            'BAGLEY  34 KV   230-2LD',
            'BESTGATE13.8 KV 110-1LD',
            'BESTGATE13.8 KV 110-2LD',
            'BESTGATE13.8 KV 110-3LD',
            'BRANDONS230 KV  AQCS1',
            'BRANDONS230 KV  AQCS2',
            'BRANDONS24 KV   GENLD1',
            'BRANDONS24 KV   GENLD2',
            'BUENAVIS13 KV   LD-XF5',
            'BUENAVIS13 KV   LD-XF6',
            'BUENAVIS34.5 KV 230-1LD',
            'BUENAVIS34.5 KV 230-2LD',
            'CALVERTC500 KV  LD3',
            'CALVERTC500 KV  LDB',
            'CALVERTC500 KV  LDR',
            'CEDARPRK13.8 KV 110-6LD',
            'CEDARPRK13.8 KV 110-7LD',
            'CEDARPRK34.5 KV 110-1LD',
            'CEDARPRK34.5 KV 110-2LD',
            'CENTER  13 KV   LOAD1',
            'CENTER  13 KV   LOAD2',
            'COLDSPRI13.8 KV T1 LOAD',
            'COLDSPRI13.8 KV T2 LOAD',
            'COLONIAL115 KV  ONE',
            'COLU BC 13.8 KV 230-1LD',
            'COLU BC 13.8 KV 230-2LD',
            'COLU BC 34.5 KV 230-4LD',
            'CONC BC 13 KV   FOUR',
            'CONC BC 13 KV   ONE',
            'CONC BC 13 KV   THREE',
            'CONC BC 13 KV   TWO',
            'CRANE   4 KV    LOAD',
            'CROWNSVI13.8 KV 110-1LD',
            'CRYSTLSP13.8 KV 110-3LD',
            'CRYSTLSP13.8 KV 110-4LD',
            'CRYSTLSP34.5 KV 110-1LD',
            'CRYSTLSP34.5 KV 110-2LD',
            'DELIGHT 13 KV   ONE',
            'DELIGHT 13 KV   TWO',
            'DOLFIELD13 KV   110-5',
            'DOLFIELD13 KV   110-6',
            'DOLFIELD34 KV   110-1',
            'DOLFIELD34 KV   110-2',
            'DOLFIELD34 KV   110-3',
            'DORSEYRN13.8 KV 110-1LD',
            'DORSEYRN13.8 KV 110-2LD',
            'E TOWSON13.8 KV 110-1LD',
            'E TOWSON13.8 KV 110-2LD',
            'E TOWSON13.8 KV 110-5LD',
            'E TOWSON34.5 KV 110-3LD',
            'E TOWSON34.5 KV 110-4LD',
            'EASTPT  34 KV   ONE',
            'EASTPT  34 KV   THREE',
            'EASTPT  34 KV   TWO',
            'EDGEWOO134.5 KV 110-4 LD',
            'EDGEWOO134.5 KV 110-5 LD',
            'ERDMAN  13 KV   ONE',
            'ERDMAN  13 KV   TWO',
            'FERNDALE13.8 KV 110-2LD',
            'FERNDALE13.8 KV 110-3LD',
            'FINKSBUR13.8 KV 110-3LD',
            'FINKSBUR34.5 KV 110-1LD',
            'FINKSBUR34.5 KV 110-2LD',
            'FRED BC 13 KV   110-3',
            'FRED BC 13 KV   110-4',
            'FRED BC 34 KV   110-1',
            'FRED BC 34 KV   110-2',
            'FULLERTO13 KV   ONE',
            'FULLERTO13 KV   TWO',
            'GENMOTOR13.8 KV 110-1 LD',
            'GENMOTOR13.8 KV 110-2 LD',
            'GLENARM 13 KV   ONE',
            'GOLDENRI13 KV   LD1',
            'GOLDENRI13 KV   LD2',
            'GOULDST 13 KV   ONE',
            'GOULDST 13 KV   TWO',
            'GRAYMANO13 KV   ONE',
            'GRAYMANO13 KV   TWO',
            'GREE BC 13 KV   LOAD1',
            'GREE BC 13 KV   LOAD2',
            'GREE BC 13 KV   LOAD3',
            'HARFORD 34.5 KV 110-1LD',
            'HARFORD 34.5 KV 110-2LD',
            'HARFORD 34.5 KV 110-7LD',
            'HARFORD 34.5 KV 110-8LD',
            'HARFORD 34.5 KV 110-9LD',
            'HARR BC 13 KV   ONE',
            'HARR BC 13 KV   THREE',
            'HARR BC 34 KV   TWO',
            'HAZELWOO115 KV  HILEN2',
            'HAZELWOO115 KV  HILEN4',
            'HAZELWOO13 KV   110-8',
            'HAZELWOO13 KV   110-9',
            'HIGHLAND13.8 KV 110-1LD',
            'HIGHLAND13.8 KV 110-2LD',
            'HIGHLAND34.5 KV 110-3LD',
            'HIGHLAND34.5 KV 110-4LD',
            'HIGHRIDG115 KV  33-1LOAD',
            'HIGHRIDG115 KV  33-2LOAD',
            'HIGHRIDG115 KV  33-3LOAD',
            'HIGHRIDG115 KV  ONE',
            'HIGHRIDG115 KV  TWO',
            'HOLLOFIE13 KV   ONE',
            'HOLLOFIE13 KV   TWO',
            'HONEYGO 13 KV   ONE',
            'HONEYGO 13 KV   TWO',
            'HOWARD  230 KV  LOAD 1',
            'HOWARD  230 KV  LOAD 2',
            'JERICHOP230 KV  ONE',
            'JERICHOP230 KV  TWO',
            'JOPPATOW13.8 KV 110-1LD',
            'JOPPATOW13.8 KV 110-2LD',
            'LIPINSCO13 KV   ONE',
            'LIPINSCO13 KV   TWO',
            'LIPINSCO34 KV   FIVE',
            'LIPINSCO34 KV   FOUR',
            'LIPINSCO34 KV   SIX',
            'LIPINSCO34 KV   THREE',
            'MARTT HL34.5 KV 110-1LD',
            'MARTT HL34.5 KV 110-2LD',
            'MEADOWBC13.8 KV 110-1LD',
            'MEADOWBC13.8 KV 110-2LD',
            'MIDDLERI13 KV   LOAD5',
            'MIDDLERI13 KV   LOAD6',
            'MIDDLERI33 KV   LOAD7',
            'MIDDLERI33 KV   LOAD8',
            'MONUMEST115 KV  FIVE',
            'MONUMEST115 KV  SIX',
            'MONUMEST13 KV   FOUR',
            'MONUMEST13 KV   ONE',
            'MONUMEST13 KV   THREE',
            'MONUMEST13 KV   TWO',
            'MTWASHIG13.8 KV T1 LOAD',
            'MTWASHIG13.8 KV T3 LOAD',
            'NAJ     13.8 KV 110-1LD',
            'NAJ     13.8 KV 110-6LD',
            'NAJ     34.5 KV 110-2LD',
            'NAJ     34.5 KV 110-3LD',
            'NAJ     34.5 KV 110-4LD',
            'NORTHEAS115 KV  110-1',
            'NORTHEAS115 KV  110-2',
            'NORTHPT 34 KV   34060LD',
            'NORTHPT 34 KV   34061LD',
            'ORCHARDS115 KV  110-1',
            'ORCHARDS115 KV  110-2',
            'ORCHARDS115 KV  110-3',
            'ORCHARDS115 KV  110-4',
            'OTTERPT 34 KV   ONE',
            'OTTERPT 34 KV   TWO',
            'PERRYMAN115 KV  110-1LD',
            'PERRYMN613.8 KV LOAD',
            'PLESNTHL13 KV   LOAD1',
            'PLESNTHL13 KV   LOAD2',
            'PLESNTHL13 KV   LOAD3',
            'PRIS BDG13.8 KV 110-3LD',
            'PRIS BDG13.8 KV 110-4LD',
            'PRIS BDG34.5 KV 110-1LD',
            'PRIS BDG34.5 KV 110-2LD',
            'PUMPHREY115 KV  110-1',
            'PUMPHREY115 KV  110-2',
            'RIDGVIEW13.8 KV 110-1LD',
            'RIDGVIEW13.8 KV 110-2LD',
            'RIVAROAD13.8 KV 110-2LD',
            'RIVAROAD34.5 KV 110-3LD',
            'RIVAROAD34.5 KV 110-4LD',
            'RIVERSID13 KV   110-4',
            'RIVERSID34 KV   LD1',
            'RIVERSID34 KV   LD2',
            'RIVERSID34 KV   LD3',
            'RIVERSID34 KV   LD4',
            'ROCKAVE 13.8 KV LOAD TR1',
            'ROCKAVE 13.8 KV LOAD TR2',
            'ROCKRIDG13 KV   LOAD3',
            'ROCKRIDG34 KV   LOAD1',
            'ROCKRIDG34 KV   LOAD2',
            'SANDYSPG13.8 KV 230-3 LD',
            'SANDYSPG13.8 KV 230-4 LD',
            'SANDYSPG34 KV   ONE',
            'SANDYSPG34 KV   TWO',
            'SHAWANRD34.5 KV 110-1LD',
            'SHAWANRD34.5 KV 110-2LD',
            'SHIPLEY 13.8 KV 110-5LD',
            'SHIPLEY 13.8 KV 110-6LD',
            'SHIPLEY 34.5 KV 110-1LD',
            'SHIPLEY 34.5 KV 110-2LD',
            'SHIPLEY 34.5 KV 110-3LD',
            'SNOWDENR13.8 KV 230-1LD',
            'SNOWDENR13.8 KV 230-2LD',
            'SNOWDENR13.8 KV 230-3LD',
            'SUDBROOK13 KV   LOAD1',
            'SUDBROOK13 KV   LOAD2',
            'SUDBROOK33 KV   LOAD3',
            'SUDBROOK33 KV   LOAD4',
            'TEXAS   13 KV   FIVE',
            'TEXAS   13 KV   THREE',
            'TEXAS   34 KV   ONE',
            'TEXAS   34 KV   TWO',
            'TIPTON  115 KV  110608LD',
            'TIPTON  115 KV  110609LD',
            'TIPTON  115 KV  110610LD',
            'TIPTON  115 KV  110611LD',
            'TIPTON  115 KV  110612LD',
            'TIPTON  115 KV  110613LD',
            'VIADUCAV13 KV   ONE',
            'WAGNER  34 KV   ONE',
            'WAGNER  34 KV   THRE',
            'WAGNER  34 KV   TWO',
            'WAUGHCHA13.8 KV 110-1LD',
            'WAUGHCHA13.8 KV 110-2LD',
            'WESMSTER13.8 KV 110-3LD',
            'WESMSTER13.8 KV 110-4LD',
            'WESMSTER34.5 KV 110-1LD',
            'WESMSTER34.5 KV 110-2LD',
            'WESTMINT115 KV  COL PIPE',
            'WESTPORT13 KV   110-10',
            'WESTPORT13 KV   110-9',
            'WESTPORT34 KV   LD34-1',
            'WESTPORT34 KV   LD34-2',
            'WHITEROC115 KV  COL PIPE',
            'WHITEROC13.8 KV 110-2LD',
            'WHITEROC34.5 KV 110-1LD',
            'WHITEROC34.5 KV 110-3LD',
            'WILDELAK13.8 KV 230-1LD',
            'WILDELAK13.8 KV 230-2LD',
            'WILDELAK13.8 KV 230-3LD',
            'WILKENS 13.8 KV LOAD1',
            'WILKENS 13.8 KV LOAD2',
            'WINDYEDG115 KV  110-1',
            'WINDYEDG115 KV  LD1',
            'WINDYEDG115 KV  LD2',
        ],
    },
    DPL: {
        pricingPoint: [
            'DPLEASTON_RESID_AGG',
            'DPL_RESID_AGG',
            'AIREY   69 KV   AIREY',
            'BAYLY   69 KV   BAYLY',
            'BAYVIEW 25 KV   LOAD19',
            'BAYVIEW 25 KV   LOAD40',
            'BAYVIEW 25 KV   LOAD62',
            'BEAGLIN 69 KV   T1LOAD',
            'BEAGLIN 69 KV   T2LOAD',
            'BELLEHAV12 KV   LOAD',
            'BERLIN DPL',
            'BERLINDP69 KV   BERLIN',
            'BETHANY 138 KV  LOAD',
            'BETHANY 69 KV   LOAD1',
            'BETHANY 69 KV   LOAD2',
            'BETHANY 69 KV   LOAD35',
            'BISHOP  138 KV  T1 LOAD',
            'BLOOMFLD69 KV   LOAD',
            'BOZMAN  69 KV   LOAD',
            'BOZMAN  69 KV   MBLTPL',
            'BRANDYWN138 KV  T5',
            'BRIDGEVI69 KV   LOADT1',
            'BRIDGEVI69 KV   LOADT2',
            'CAMBRIDG69 KV   LOADT3',
            'CAMBRIDG69 KV   LOADT4',
            'CARTANZA230 KV  LD1',
            'CARVILLE138 KV  MT',
            'CARVILLE138 KV  T1',
            'CARVILLE138 KV  T2',
            'CEDARCRE138 KV  T1',
            'CEDARNEC69 KV   T1 LOAD',
            'CEDARNEC69 KV   T2 LOAD',
            'CENTREVL69 KV   448',
            'CENTREVL69 KV   449',
            'CHESTERT69 KV   2245LD',
            'CHESTERT69 KV   2246LD',
            'CHESWOLD138 KV  T3',
            'CHINCOTE69 KV   LOADT1',
            'CHINCOTE69 KV   LOADT2',
            'CHR138  12 KV   1B LOAD',
            'CHR138  12 KV   2B LOAD',
            'CHR138  12 KV   3B LOAD',
            'CHURCH  69 KV   T3',
            'CHURCH  69 KV   T4',
            'CLAYTON 138 KV  LDSMY',
            'CLAYTON 138 KV  LOADT1',
            'CLAYTON 138 KV  LOADT2',
            'CLOUGH  69 KV   LOAD',
            'CONAWAY 138 KV  T1',
            'CONCRDDP69 KV   CONCRD',
            'CONCRDDP69 KV   CONCRD1',
            'COSTEN  138 KV  COSTEN',
            'CREST   230 KV  T1 LOAD',
            'CREST   230 KV  T2 LOAD',
            'CRISFIE 12 KV   LOAD',
            'CRISFIE 12 KV   LOAD12',
            'CRISFIE 25 KV   LOAD25',
            'CULVER  69 KV   CULVER',
            'DELA DPL13 KV   T2',
            'DEMEC',
            'DOVER',
            'DPL DE',
            'DPL MD',
            'DPL_ODEC',
            'DUPSEAFD12 KV   PP1A',
            'DUPSEAFD12 KV   PP2B',
            'EASTVILL69 KV   EASTVL',
            'EDGEMOOR12 KV   T1',
            'EDGEMOOR230 KV  SSLD',
            'EDGEMOOR69 KV   SST2',
            'EDGEWDPL69 KV   EDGEWD',
            'EMUNI   69 KV   E-MUNI',
            'ENEWMARK69 KV   E-NMKT',
            'ENEWMKTR69 KV   ENMKTR',
            'FAIRMONT69 KV   FAIRMT',
            'FAIRMONT69 KV   LOAD1',
            'FAIRMONT69 KV   LOAD2',
            'FARMVIEW138 KV  LOAD1',
            'FELTON  25 KV   LOAD1',
            'FIVEPTS 69 KV   LOADT1',
            'FIVEPTS 69 KV   LOADT2',
            'FRANKFOR138 KV  FRANK',
            'FRUITLAN69 KV   LOADT1',
            'FRUITLAN69 KV   LOADT2',
            'GRACEST 69 KV   T1 LOAD',
            'GRACEST 69 KV   T2 LOAD',
            'GREENBUS69 KV   GRNBSH',
            'GRSNVILL69 KV   T1',
            'GRSNVILL69 KV   T2',
            'HALLWOOD69 KV   HALLWD',
            'HARBESON69 KV   HARBT1',
            'HARBESON69 KV   HARBT2',
            'HARRTN  69 KV   T1',
            'HARRTN  69 KV   T2',
            'HARRTN  69 KV   VERNON',
            'HEBRON  69 KV   LOAD 1',
            'HEBRON  69 KV   LOAD 2',
            'HILLSBRO138 KV  HLSBRO',
            'IBCORN  69 KV   IBCORN',
            'INDIANRI69 KV   LOAD1',
            'INDIANRI69 KV   LOAD2',
            'JACKTOWN69 KV   JACTWN',
            'JONES   138 KV  JONES',
            'KEENEY  230 KV  T2',
            'KELLAM  69 KV   T1 LOAD',
            'KELLAM  69 KV   T2 LOAD',
            'KENNEDYV69 KV   KNDYVL',
            'KENNEY  24 KV   T1',
            'KENNEY  24 KV   T2',
            'KENT    69 KV   DEC LOAD',
            'KENT    69 KV   T1',
            'KENT    69 KV   T2',
            'KINGSCRK138 KV  LOADT1',
            'KINGSCRK138 KV  LOADT2',
            'KINGSTON69 KV   KNGSTN',
            'KRATZ   69 KV   KRATZ',
            'LANKREA 69 KV   LANK',
            'LAURELDP69 KV   LOADT1',
            'LAURELDP69 KV   LOADT2',
            'LEWES DPL',
            'LEWESREA69 KV   LEWES',
            'LONGWOOD69 KV   LONGWD',
            'LORETTO 69 KV   PRNCSS',
            'LYNCH   69 KV   T1',
            'MARDELA 69 KV   MARREA',
            'MARIDEL 69 KV   LOADT1',
            'MARIDEL 69 KV   LOADT2',
            'MASSEY  69 KV   MASSEY',
            'MASSEYRE69 KV   MASREA',
            'MIDDLETO138 KV  T1',
            'MIDWAY  69 KV   T1 LOAD',
            'MIDWAY  69 KV   T2 LOAD',
            'MILFORD 138 KV  13702',
            'MILFORD 138 KV  LOADT1',
            'MILFORD 138 KV  LOADT2',
            'MILLTOWN138 KV  LOADT4',
            'MILSBORO69 KV   LOADT1',
            'MILSBORO69 KV   LOADT2',
            'MOTIVA  138 KV  SS LOAD',
            'MTHERMON69 KV   LOADT1',
            'MTHERMON69 KV   LOADT2',
            'MTOLIVE 69 KV   MT-OLV',
            'MTPLEASN138 KV  T1LOAD',
            'NAAMANS',
            'NELSON  138 KV  LOADT2',
            'NELSON  138 KV  LOADT3',
            'NEWHOPE 69 KV   N-HOPE',
            'NEWMERED69 KV   N-MERD',
            'NORTHST 69 KV   ONE',
            'NSALISBU69 KV   LOADT1',
            'NSALISBU69 KV   LOADT2',
            'NSEAFORD69 KV   LOADT3',
            'OAKHALL 25 KV   T1',
            'OCEANBAY138 KV  LOADT1',
            'OCEANBAY138 KV  LOADT2',
            'OCEANCTY69 KV   LOADT1',
            'OCEANCTY69 KV   LOADT2',
            'OCEANPIN69 KV   OCNPIN',
            'OILCITY 138 KV  LOAD1',
            'OMAR    138 KV  LOAD1',
            'PEMBERTO69 KV   T-1',
            'PEPPER  69 KV   PEPPER',
            'PERDUE  69 KV   LOAD1',
            'PINE ST 69 KV   SEACTY',
            'POCOMOKE138 KV  LOAD1',
            'POCOMOKE138 KV  LOAD2',
            'PRESTON 69 KV   PRSTON',
            'PRICE   69 KV   PRICE T1',
            'REDLION T1',
            'REHOBOTH69 KV   REHT1',
            'REHOBOTH69 KV   REHT2',
            'ROBINS  138 KV  ANGOLA',
            'ROBINS  138 KV  T1 LOAD',
            'ROCKWLKN69 KV   LOAD1',
            'ROXANA  138 KV  DEC1',
            'ROXANA  138 KV  DEC2',
            'ROYOAK  69 KV   LOAD',
            'SHARP   69 KV   SHARP',
            'SHORT   69 KV   SHORT',
            'SIGNPOST69 KV   LOAD',
            'SINPUX  69 KV   SINPUX',
            'ST138   138 KV  LOADT1',
            'ST138   138 KV  LOADT2',
            'STEELE  138 KV  T3',
            'STOCKTON69 KV   LOADT1',
            'STOCKTON69 KV   LOADT2',
            'STVNSVIL69 KV   T1',
            'STVNSVIL69 KV   T2',
            'SUSSEX  69 KV   LOADT1',
            'SUSSEX  69 KV   LOADT2',
            'TALBOT  69 KV   TALBOT',
            'TANYARD 69 KV   TANYRD',
            'TASLEY  12 KV   LOADSS',
            'TASLEY  69 KV   LOADT1',
            'TASLEY  69 KV   LOADT4',
            'TAYLOR  69 KV   TAYLOR',
            'TODD    25 KV   LOADT2',
            'TODD    25 KV   LOAD_T1',
            'TODD    69 KV   ALLENREA',
            'TODD    69 KV   LOADT3',
            'TOWNSEND138 KV  MIDLETWN',
            'TOWNSEND138 KV  ONE',
            'TRAPPETP69 KV   T4LOAD',
            'TRAPPETP69 KV   TRAPPE',
            'VAUGHN  69 KV   VAUGHN',
            'VIENNA  69 KV   T8B',
            'VIENNALO69 KV   VN-LOC',
            'WALLOPS 69 KV   WALOPS',
            'WALSTON 69 KV   WALSTN',
            'WATTSVIL69 KV   LOADT1',
            'WATTSVIL69 KV   LOADT2',
            'WCAMBRID69 KV   W-CAMB',
            'WEIRWDTP69 KV   LOAD1',
            'WELLS   69 KV   WELLSLD',
            'WORCESTE69 KV   LOADT1',
            'WORCESTE69 KV   LOADT2',
            'WOVERDPL69 KV   WSTOVR',
            'WYEMILLS69 KV   LOADT2',
            'WYEMILLS69 KV   LOADT3',
        ],
    },
    PSEG: {
        pricingPoint: ['PSEG_RESID_AGG', 'BRUNSWICK', 'HILLSDALE_PARKRIDGE'],
    },
    DUQ: {
        pricingPoint: ['DUQ_RESID_AGG'],
    },
    EKPC: {
        pricingPoint: ['EKPC_RESID_AGG'],
    },
    PECO: {
        pricingPoint: ['PECO_RESID_AGG'],
    },
    PEPCO: {
        pricingPoint: ['SMECO_RESID_AGG', 'MORGANTO230 KV  RSST1', 'MORGANTO230 KV  RSST2', 'PEPCO DC', 'PEPCO MD'],
    },
    OVEC: {
        pricingPoint: [''],
    },
    RECO: {
        pricingPoint: ['RECO_RESID_AGG'],
    },
};

export const ZONE = Object.keys(ZONE_DEP_MAP).sort();
export const PRICING_POINT = _.uniq(_.flatten(Object.values(ZONE_DEP_MAP).map(it => it.pricingPoint))).sort();
export const STATE = _.uniq(_.flatten(Object.values(EDC_DEP_MAP).map(it => it.state))).sort();

export const LSE_VALUES = [
    'AE',
    'AECI',
    'AEMN',
    'AEMR',
    'AEPAPD',
    'AEPBMB',
    'AEPCOW',
    'AEPIMD',
    'AEPKPD',
    'AEPOPD',
    'AEPREP',
    'AEPSBY',
    'AEPSCG',
    'AEPWPD',
    'AESAVB',
    'AESDLR',
    'AESPER',
    'AESPPR',
    'AESWPR',
    'AETSAP',
    'AGEBGE',
    'AHC',
    'AKSTL',
    'AMBTMD',
    'AMPAEP',
    'AMPCEL',
    'AMPDAN',
    'AMPDAY',
    'AMPEPH',
    'AMPFE',
    'AMPGPU',
    'AMPHAM',
    'AMPLEB',
    'AMPO',
    'AMPOMG',
    'AMPPEN',
    'AMPPER',
    'AMPPIQ',
    'AMPPPL',
    'AMPWV',
    'AMRNPP',
    'APGEPA',
    'APMDPL',
    'APMP',
    'APMPEP',
    'APNAPS',
    'APNBG2',
    'APNM',
    'APNMAE',
    'APNMI',
    'APNMT',
    'APNPL5',
    'APSFAP',
    'APSFDP',
    'APSFDQ',
    'APSFME',
    'APVDII',
    'APWVP',
    'ARCMIT',
    'ASTRLE',
    'ATLMD',
    'BARBMB',
    'BARCS',
    'BATAV',
    'BC',
    'BEDFRD',
    'BEES',
    'BGEMDH',
    'BLUAEP',
    'BLUBGE',
    'BLUDL1',
    'BLUDMD',
    'BLUPEP',
    'BLUSTR',
    'BOCES',
    'BPPDC',
    'BRFRYL',
    'BRLNMD',
    'BSHNJ',
    'BSRNJ',
    'BUCK',
    'CBBTU',
    'CCES',
    'CE-EA',
    'CEBMB',
    'CECBGE',
    'CECGCV',
    'CECMPS',
    'CECMX',
    'CEDEO',
    'CEDS',
    'CEPDC',
    'CESBMB',
    'CESNJ',
    'CESREC',
    'CHBDTE',
    'CHMAEC',
    'CHMAOH',
    'CHMBGE',
    'CHMDAY',
    'CHMDEO',
    'CHMDPL',
    'CHMDUQ',
    'CHMFEO',
    'CHMJCP',
    'CHMMET',
    'CHMPCE',
    'CHMPEC',
    'CHMPED',
    'CHMPEN',
    'CHMPEP',
    'CHMPN',
    'CHMPPB',
    'CHMPPL',
    'CHMPPP',
    'CHMPSG',
    'CHMSDM',
    'CHMSDP',
    'CHMWPP',
    'CLRVMD',
    'CNEDAY',
    'CNEPNM',
    'COMED',
    'ConEdE',
    'CPBMB',
    'CPP',
    'CPSBMB',
    'CPSI',
    'CRS',
    'CSSC',
    'CSUSA',
    'CTZECL',
    'CVEC',
    'DAYDEO',
    'DAYEDC',
    'DAYERI',
    'DAYTON',
    'DECCAP',
    'DEK',
    'DEMEC',
    'DEOEDC',
    'DEOLSE',
    'DISCEG',
    'DISPWR',
    'DLCHPS',
    'DLCO',
    'DLCZCA',
    'DLE',
    'DOMBGE',
    'DOMCIN',
    'DOMDL3',
    'DOMEDC',
    'DOMJCP',
    'DOMLSE',
    'DOMMED',
    'DOMPPC',
    'DOMPPL',
    'DOMRET',
    'DOVDE',
    'DPL',
    'DPLDEH',
    'DPLDR',
    'DPLMDH',
    'DTEBMB',
    'DTESAE',
    'DTESPN',
    'DUQPWR',
    'DWPEH',
    'DYNES',
    'EABMB',
    'EACEB',
    'EAGLEE',
    'EALLC',
    'EAMM',
    'EASTON',
    'ECNY',
    'EDADEO',
    'EDFAL',
    'EDFAPM',
    'EDFBGE',
    'EDFNJ',
    'EDFNPC',
    'EDFSBG',
    'EDFXCE',
    'EDFXE',
    'EDFXMD',
    'EEAP',
    'EIPAPV',
    'EIPCMC',
    'EIPDEO',
    'EIPDOM',
    'EIPJCP',
    'EIPSFE',
    'EIPSIL',
    'EIPSPL',
    'EKPC',
    'ELIOGO',
    'EMMT',
    'EMTBMB',
    'EPLBMB',
    'EPLMDR',
    'EPLTAR',
    'EPLUS',
    'EPLUSH',
    'EVRZCL',
    'EXGMME',
    'EXGSRE',
    'FESC',
    'FESDLM',
    'FESDLS',
    'FESDUQ',
    'FESNMB',
    'FPLBD',
    'FPLBMB',
    'FPLG01',
    'FPLG02',
    'FPLG03',
    'FPLG04',
    'FPLG05',
    'FPLG06',
    'FPLG07',
    'FPLG08',
    'FPLG09',
    'FPLG10',
    'FPLG11',
    'FPLG12',
    'FPLG13',
    'FPLG14',
    'FPLG15',
    'FPLG16',
    'FPLG20',
    'FPLG26',
    'FPLG27',
    'FPPBGE',
    'FPSBGE',
    'FPSCED',
    'FPSDOH',
    'FPSDPL',
    'FPSDUQ',
    'FPSFME',
    'FPSFPE',
    'FPSPEP',
    'GENEVA',
    'GENJ',
    'GERDAP',
    'GESC',
    'GMCOML',
    'GMRESL',
    'GRNLGT',
    'HEREC',
    'HESBMB',
    'HESBMR',
    'HESEMK',
    'HESSBS',
    'HESSPS',
    'HESSPU',
    'HESSR',
    'HESUMM',
    'HIKOE',
    'HLMUS',
    'HPL',
    'HSBCUS',
    'HUDSON',
    'IDTE',
    'IESCED',
    'IESMA',
    'IMEAA1',
    'INDR01',
    'INDR02',
    'INDR03',
    'INDR04',
    'INDR05',
    'INTGSI',
    'ISGSP',
    'ISGSPL',
    'JARNP',
    'JCBGS',
    'JCDLC',
    'JOSUBC',
    'JOSUPD',
    'JRAPL',
    'KCCI',
    'KSISEN',
    'LESBRD',
    'LESBUT',
    'LESCLY',
    'LESDAT',
    'LESLEM',
    'LESLIM',
    'LESPL',
    'LINATE',
    'LPFE',
    'LPH',
    'LPMD',
    'MA',
    'MCPBMB',
    'MCPCNB',
    'MCPESP',
    'MCPETH',
    'MCPGAP',
    'MCPMAR',
    'MCPSPD',
    'MCPSPN',
    'MCPVRD',
    'MECR',
    'MEDBGE',
    'MEEDEL',
    'MEEPEP',
    'MEES',
    'MetEd',
    'MIDAES',
    'MP2ENE',
    'MP2JC',
    'MPENJ',
    'MRTNSV',
    'NAPDUK',
    'NAPG',
    'NATLBG',
    'NATPEP',
    'NEASTS',
    'NEEBM2',
    'NES',
    'NEV',
    'NEVEAS',
    'NEVWES',
    'NVEC',
    'ODEC',
    'ODECS',
    'OEEDC',
    'OPOE',
    'OSPLAB',
    'OSPTJX',
    'PaElec',
    'PALMMD',
    'PALMNJ',
    'PALMOH',
    'PAPWR',
    'PARKP',
    'PBFPM',
    'PE',
    'PEPAG1',
    'PEPAG2',
    'PEPAG3',
    'PEPCO',
    'PEPDCH',
    'PEPDR',
    'PEPDVP',
    'PEPMDH',
    'PEPSRV',
    'PJMT3',
    'PLYMRE',
    'PPL',
    'PPUMD',
    'PPUNJ',
    'PPWDUK',
    'PPWNY',
    'PREMPM',
    'PRTBMB',
    'PSEG',
    'PSERT',
    'PUREUS',
    'RADFRD',
    'RCHLDS',
    'RECO',
    'RELENE',
    'REPS',
    'RESCOM',
    'RESI',
    'ROCH',
    'RPAMD',
    'SALEM',
    'SELLC',
    'SENAEP',
    'SES',
    'SESAEC',
    'SESAEP',
    'SESBGE',
] as const;
